

















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyCommon from "@/mixins/common";

import SelectStadium from "@/components/selectstadium.vue";

import VChart, { THEME_KEY } from "vue-echarts";

@Component({
  components: {
    VChart,
    SelectStadium
  },
  provide: {
    [THEME_KEY]: "light"
  }
})
export default class extends Mixins(MyCommon) {
  @Prop() params!: any;

  option: any = {
    grid: {
      containLabel: true
    },
    tooltip: {
      trigger: "axis"
    },
    legend: {
      data: ["羽约运动App", "羽约场馆App"]
    },
    xAxis: {
      type: "category",
      name: "日期",
      data: []
    },
    yAxis: {
      type: "value",
      name: "人"
    },
    series: [
      {
        data: [],
        name: "羽约运动App",
        type: "line",
        markPoint: {
          data: [{ type: "max", name: "最大值" }, { type: "min", name: "最小值" }]
        },
        markLine: {
          data: [{ type: "average", name: "平均值" }]
        }
      },
      {
        data: [],
        name: "羽约场馆App",
        type: "line",
        markPoint: {
          data: [{ type: "max", name: "最大值" }, { type: "min", name: "最小值" }]
        },
        markLine: {
          data: [{ type: "average", name: "平均值" }]
        }
      }
    ]
  };

  ei: any = {};

  selectSearchStadium(e: any) {
    // console.log(e);
    this.params.stadium_id = e;
    this.loadChart();
  }

  async loadChart() {
    this.option.xAxis.data = [];

    const res = await this.$store.dispatch("statistics/dailyActiveUser", {
      ...this.params,
      start_time: this.moment(this.params.start_time).format("YYYY-MM-DD HH:mm:ss"),
      end_time: this.moment(this.params.end_time).format("YYYY-MM-DD HH:mm:ss"),
      service: 2,
      action_name: "USER_INFO"
    });
    if (res && res.Data) {
      this.option.xAxis.data = res.Data.categories;

      this.option.series[0].data = [];
      for (const k in res.Data.data) {
        // console.log(k);
        if (res.Data.data[k]) {
          this.option.series[0].data.push(res.Data.data[k]);
        } else {
          this.option.series[0].data.push(0);
        }
      }
    }

    const res1 = await this.$store.dispatch("statistics/dailyActiveUser", {
      ...this.params,
      start_time: this.moment(this.params.start_time).format("YYYY-MM-DD HH:mm:ss"),
      end_time: this.moment(this.params.end_time).format("YYYY-MM-DD HH:mm:ss"),
      service: 3,
      action_name: "STADIUM_USER_INFO"
    });
    if (res1 && res1.Data) {
      this.option.series[1].data = [];
      for (const k in res1.Data.data) {
        // console.log(k);
        if (res1.Data.data[k]) {
          this.option.series[1].data.push(res1.Data.data[k]);
        } else {
          this.option.series[1].data.push(0);
        }
      }
    }
  }

  mounted() {
    this.loadChart();
  }

  changeDate(dates: any[], dateStrings: any[]) {
    this.params.start_time = `${dateStrings[0]} 00:00:00`;
    this.params.end_time = `${dateStrings[1]} 23:59:59`;
    this.loadChart();
  }
}
